// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xngGetCategories } from "@gcg/App/Services/CategoryService";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    if (BLUEPRINT_NAME !== "electrowire") {
        props.apiParameter = { ...props.apiParameter, expand: "featuredproducts", numberoffeaturedproducts: 2 } as any;
    } else if (BLUEPRINT_NAME === "electrowire") {
        props.apiParameter = { ...props.apiParameter, showSubCategoriesHtmlContent: true } as any;
    }
};

// XNG-Changes: EIS-1037: Fixing htmlContent not being showing in category navigation
export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    props.apiResult = await xngGetCategories(props.apiParameter);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
